import React from 'react';
import { Button } from 'tuui';
import { AlertIcon } from 'taboola-ultimate-ui';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { GTM_EVENTS } from 'modules/taboola-common-frontend-modules/gtmTracker';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './eventsHeader.module.scss';

export const EventsHeader = ({ issueCount }) => {
    const { value: pixelTesterEvents, onChange: onChangePixelTesterEvents } = useFormFieldValue({
        field: 'pixelTesterEvents',
    });

    const clearActivity = () => {
        onChangePixelTesterEvents([]);
    };

    return (
        <div className={styles['header']}>
            <FormattedMessage
                id="pixel.tester.events.header.title"
                defaultMessage="Events Received"
                className={styles['title']}
            />
            <div className={styles['button-issue-container']}>
                {issueCount > 0 && (
                    <div className={styles['issue-container']}>
                        <FormattedMessage
                            id={
                                issueCount === 1
                                    ? 'pixel.tester.events.header.issues.single'
                                    : 'pixel.tester.events.header.issues.multiple'
                            }
                            defaultMessage={issueCount === 1 ? '1 Issue' : '{issueCount} Issues'}
                            values={{ issueCount }}
                            className={styles['issues-label']}
                        />
                        <AlertIcon className={styles['alert-icon']} />
                    </div>
                )}
                <Button
                    id="PIXEL_TESTER_CLEAR_ACTIVITY_BTN"
                    className={styles['button']}
                    variant={Button.variant.ghost}
                    onClick={clearActivity}
                    disabled={!pixelTesterEvents?.length}
                    data-metrics-event-name={GTM_EVENTS.USABILITY}
                    data-metrics-component={EventsHeader.name}
                    data-metrics-value="PIXEL_TESTER_CLEAR_ACTIVITY"
                >
                    <FormattedMessage id="pixel.tester.events.header.clear.activity" defaultMessage="Clear Activity" />
                </Button>
            </div>
        </div>
    );
};
